<template>
  <div id="agEmailConn"></div>
</template>


<script>
// components

// server

// modules

export default {
  name: "ag-email-conn",

  props: {
    isReadonly: Boolean,
    connection: Object
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    // UI Events

    // other

    reset() {},

    prepareForSave() {}
  }
};
</script>


<style scoped lange="css">
</style>


// WEBPACK FOOTER //
// src/components/connection/EmailConnection.vue